import { render, staticRenderFns } from "./DashbordBooking.vue?vue&type=template&id=6f5f3d94&"
import script from "./DashbordBooking.vue?vue&type=script&lang=js&"
export * from "./DashbordBooking.vue?vue&type=script&lang=js&"
import style0 from "./DashbordBooking.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports